import React from 'react';

import PopUp from '../../Popup';
import UpgradeToPerformanceHsContent from './UpgradeToPerformanceHsContent';

const UpgradeToPerformanceHsPopUp = (props) => {
    const {
        onCloseClick,
        handleUpgradeClick,
        clubOptionsToUpgrade,
    } = props;

    return (
        <div>
            <PopUp
                className="popup-md"
                config={{
                    style: {
                        height: 540,
                        maxHeight: '80vh',
                    },
                    fullScreen: true,
                    noPadding: false,
                }}
                onCloseClick={onCloseClick}
            >
                <UpgradeToPerformanceHsContent
                    handleUpgradeClick={handleUpgradeClick}
                    clubOptionsToUpgrade={clubOptionsToUpgrade}
                />
            </PopUp>
        </div>
    );
};

export default UpgradeToPerformanceHsPopUp;
